import { ObjectDb } from './object.db';
import { Injectable } from '@angular/core';
import {
    ServiceVisitTypeObject,
} from '@libs/types/src/services/object-type/service/settings/service-visit-type.object';

@Injectable({ providedIn: 'root' })
export class ServiceVisitTypeDb extends ObjectDb<ServiceVisitTypeObject> {

    public tableName = 'serviceVisitType';

    protected override columnMap = {};
    protected override indices = ['id', 'serviceId'];
    protected override checkField = 'createdAt';

    protected gqlMethod = 'getServiceVisitTypes';

    protected override refreshOnUserChange = false;

    protected syncFragment = `
        id
        name
        serviceId
        createdAt
    `;

}
